import { Copy as Copy_kojaro } from './Copy.kojaro';
import { Copy as Copy_phosphor } from './Copy.phosphor';
import { Copy as Copy_zoomg } from './Copy.zoomg';
import { Copy as Copy_zoomit } from './Copy.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return Copy_kojaro;

    case 'zoomg':
      return Copy_zoomg;

    case 'phosphor':
      return Copy_phosphor;

    default:
      return Copy_zoomit;
  }
};

export const Copy = IconRenderer();
